import { createFileRoute } from "@tanstack/react-router";

import { RequestSubmitPage } from "@/features/my/requests/submit";

export const Route = createFileRoute(
  "/(member)/(protected)/my/requests/submit",
)({
  component: RequestSubmitPage,
});
